import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';
import { forwardRef } from 'react';

export const UserDefinedIcon = forwardRef<SVGSVGElement, SvgWrapperProps>(
  (props, ref) => (
    <SvgWrapper fill='none' ref={ref} viewBox='0 0 16 16' {...props}>
      <path
        d='M14.5 9.5L13.5 4.5L10.5 1.5H5.5L2.5 4.5L1.5 9.5'
        stroke='currentColor'
      />
      <path
        d='M10.5 9C10.5 10.3807 9.38071 11.5 8 11.5C6.61929 11.5 5.5 10.3807 5.5 9C5.5 7.61929 6.61929 6.5 8 6.5C9.38071 6.5 10.5 7.61929 10.5 9Z'
        stroke='currentColor'
      />
      <path
        d='M5.59972 10.7999C4.62832 11.5297 4 12.6915 4 14V16H12V14C12 12.6915 11.3717 11.5297 10.4003 10.7999C10.195 11.0733 9.9441 11.3104 9.6589 11.5C10.4672 12.0375 11 12.9565 11 14V15H5V14C5 12.9565 5.53275 12.0375 6.3411 11.5C6.0559 11.3104 5.80501 11.0733 5.59972 10.7999Z'
        fill='currentColor'
      />
      <circle cx='2.5' cy='4.5' r='1.5' fill='currentColor' />
      <circle cx='1.5' cy='9.5' r='1.5' fill='currentColor' />
      <circle cx='10.5' cy='1.5' r='1.5' fill='currentColor' />
      <circle cx='5.5' cy='1.5' r='1.5' fill='currentColor' />
      <circle cx='13.5' cy='4.5' r='1.5' fill='currentColor' />
      <circle cx='14.5' cy='9.5' r='1.5' fill='currentColor' />
    </SvgWrapper>
  ),
);

UserDefinedIcon.displayName = 'UserDefinedIcon';
